import { createSlice } from "@reduxjs/toolkit";
import { VendaConsignatarioModel } from "../../../models/vendaConsignatario/vendaConsignatarioModel";
import { buscarAnexosVendaConsignatario, buscarVendaConsignatario } from "../../../services/vendaConsignatarioService";
import { BuscarVendaConsignatarioModel } from "../../../models/vendaConsignatario/buscarVendaConsignatarioModel";
import { ArquivoAnexoConsignatarioModel } from "../../../models/vendaConsignatario/arquivoAnexoConsignatarioModel";
import { PrestacaoContaModel } from "../../../models/prestacaoConta/prestacaoContaModel";
import { resetAll } from "../../actions/actions";

export interface VendaConsignatarioState {
  //buscar venda consignatario
  loading: boolean;
  busca: BuscarVendaConsignatarioModel;
  list: VendaConsignatarioModel[];
  entity: VendaConsignatarioModel;
  //buscar anexos venda consignatario
  loadingAnexo: boolean;
  listAnexo: ArquivoAnexoConsignatarioModel[];
  //internal
  anexoConsignatario: PrestacaoContaModel;
}

const initialState: VendaConsignatarioState = {
  //buscar venda consignatario
  loading: false,
  busca: {
    idSorteio: null,
    idEmpresa: null,
    idConsignatario: null,
  } as BuscarVendaConsignatarioModel,
  list: [],
  entity: {} as VendaConsignatarioModel,
  //buscar anexos venda consignatario
  loadingAnexo: false,
  listAnexo: [],
  //internal
  anexoConsignatario: {} as PrestacaoContaModel,
};

export const vendaConsignatarioSlice = createSlice({
  name: "vendaConsignatario",
  initialState,
  reducers: {
    //buscar venda consignatario
    setBuscaVendaConsignatario: (state, action) => {
      state.busca = action.payload;
    },
    setEntityVendaConsignatario: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setAnexoConsignatario: (state, action) => {
      state.anexoConsignatario = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar venda consignatario
    builder.addCase(buscarVendaConsignatario.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarVendaConsignatario.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarVendaConsignatario.rejected, (state, action) => {
      state.loading = false;
    });

    //buscar anexos venda consignatario
    builder.addCase(buscarAnexosVendaConsignatario.pending, (state) => {
      state.loadingAnexo = true;
    });
    builder.addCase(buscarAnexosVendaConsignatario.fulfilled, (state, action) => {
      state.listAnexo = action.payload;
      state.loadingAnexo = false;
    });
    builder.addCase(buscarAnexosVendaConsignatario.rejected, (state, action) => {
      state.loadingAnexo = false;
    });
  },
});

export const {
  //buscar venda consignatario
  setBuscaVendaConsignatario,
  setEntityVendaConsignatario,
  //internal
  setAnexoConsignatario,
} = vendaConsignatarioSlice.actions;

export default vendaConsignatarioSlice.reducer;
